export default __webpack_public_path__ + "static/media/link.482e8c03.svg";